import { Mail } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function VerifyEmailPage() {
  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="bg-accent-light/30 mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full">
            <Mail className="text-accent h-6 w-6" />
          </div>
          <CardTitle className="text-primary text-2xl font-normal">Check your email</CardTitle>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-muted text-sm">
            We&apos;ve sent a verification link to your email address. Click the link to verify your
            account, then come back to sign in.
          </p>
          <Button
            asChild
            className="bg-accent text-accent-foreground hover:bg-accent/90 mt-6 w-full"
          >
            <Link to="/login">Back to sign in</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
